// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface GenerateTOTPSecret {

}

export interface TOTPSecret {
  errorText?: string
  qr?: string
  manualCode?: string
}

/**
 * Validate GenerateTOTPSecret request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param _request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateGenerateTOTPSecret(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateGenerateTOTPSecret(_request: GenerateTOTPSecret): ValidationError[] {
  const errors: ValidationError[] = []



  return errors
}

export const generateTOTPSecret = postEndpoint<GenerateTOTPSecret, TOTPSecret>('/user/generateTOTPSecret')
